import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';

const getTexts = (T, filters) => {
  const hasSearch = !!filters.searchExpression;
  const hasFilters = !!Object.keys(filters).filter(
    (k) => k !== 'searchExpression',
  ).length;
  if (hasSearch && hasFilters) {
    return {
      description: T.translate('NO_SEARCH_AND_FILTER_RESULTS'),
      clearText: T.translate('SHOW_ALL'),
    };
  } else if (hasSearch) {
    return {
      description: T.translate('NO_SEARCH_RESULTS'),
      clearText: T.translate('CLEAR_SEARCH'),
    };
  }
  return {
    description: T.translate('NO_FILTER_RESULTS'),
    clearText: T.translate('CLEAR_FILTERS'),
  };
};

const EntityPickerModalNoSearchResults = ({ clearFilters, filters }) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const { description, clearText } = getTexts(T, filters);
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_PHOTO_GREY}
      title={T.translate('NO_RESULTS_TITLE')}
      description={description}
    >
      <LinkButton onClick={clearFilters}>{clearText}</LinkButton>
    </EmptyState>
  );
};

EntityPickerModalNoSearchResults.propTypes = {
  /**
   * Callback to set filters.
   */
  clearFilters: PropTypes.func,
  /**
   * The currently applied filters.
   */
  filters: PropTypes.object,
};

export default EntityPickerModalNoSearchResults;
